import util from '../util';

export const FNI_VERIFICATION = 'FNI_VERIFICATION';

export const FNI_VERIFICATION_REQUEST = util.requestType(FNI_VERIFICATION);
export const FNI_VERIFICATION_SUCCESS = util.successType(FNI_VERIFICATION);
export const FNI_VERIFICATION_FAILURE = util.failureType(FNI_VERIFICATION);
export const FNI_VERIFICATION_RESET = util.resetType(FNI_VERIFICATION);
